export default __webpack_public_path__ + "static/media/Note.7c6fd526.jpg";